import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const formatTerm = (coefficient, variable, first = false) => {
  if (coefficient === 0) return "";
  const sign = coefficient < 0 ? "-" : first ? "" : "+";
  const absolute = Math.abs(coefficient);
  const coefficientText = absolute === 1 && variable ? "" : String(absolute);
  return `${sign}${coefficientText}${variable}`;
};

export function generateTask() {
  const formulaType = Math.random() < 0.5 ? "linear" : "quadratic";
  const a = formulaType === "linear" ? randomInt(-4, 4) || 2 : randomInt(-2, 2) || 1;
  const b = formulaType === "linear" ? randomInt(-6, 6) : randomInt(-4, 4);
  const c = formulaType === "quadratic" ? randomInt(-5, 5) : 0;
  const n = randomInt(3, 5);
  const terms = Array.from({ length: n }, (_, index) => {
    const termIndex = index + 1;
    return formulaType === "quadratic"
      ? a * termIndex ** 2 + b * termIndex + c
      : a * termIndex + b;
  });
  const sum = terms.reduce((total, value) => total + value, 0);
  const formulaLatex = formulaType === "quadratic"
    ? `${formatTerm(a, "n^2", true)}${formatTerm(b, "n")}${formatTerm(c, "")}`
    : `${formatTerm(a, "n", true)}${formatTerm(b, "")}`;

  return {
    type: "SumInitialTermsFromFormulaTask",
    data: { a, b, c, n, terms, sum, formulaType, formulaLatex },
  };
}

export function renderTask({ data }) {
  return (
    <div className="space-y-2">
      <p>Dany jest ciąg określony wzorem ogólnym:</p>
      <BlockMath math={`a_n=${data.formulaLatex}`} />
      <p>
        Oblicz sumę pierwszych <InlineMath math={String(data.n)} /> wyrazów tego ciągu,
        czyli <InlineMath math={`S_${data.n}`} />.
      </p>
    </div>
  );
}

export function renderInput({ data }, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      label={`S_{${data.n}}`}
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  return Number.isFinite(userAnswer?.parsed) && Math.abs(userAnswer.parsed - data.sum) < 0.01;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`S_{${data.n}}=${data.sum}`} />;
}

export function renderExplanation({ data }) {
  const calculations = data.terms.map((value, index) => `a_${index + 1}=${value}`).join("\\qquad ");
  const sumLatex = data.terms
    .map((value, index) => index === 0 ? String(value) : value < 0 ? `-${Math.abs(value)}` : `+${value}`)
    .join("");
  return (
    <div className="space-y-3">
      <p><strong>Krok 1.</strong> Obliczamy po kolei potrzebne wyrazy.</p>
      <BlockMath math={calculations} />
      <p><strong>Krok 2.</strong> Dodajemy otrzymane liczby.</p>
      <BlockMath math={`S_${data.n}=${sumLatex}=${data.sum}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer, task) {
  if (!userAnswer?.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`S_{${task?.data?.n ?? "n"}}=${userAnswer.raw}`} />;
}
